import React, { memo } from 'react';
import { Tabs, Tab } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { PAGE_START, ROUTES_PAGE } from '../../../constants/routes';

const StyledTabs = withStyles({
  root: {
    padding: '0 0.938rem',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
  },
  indicator: {
    backgroundColor: 'black',
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: 0,
    color: 'black',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(16),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    lineHeight: '1.25rem',
    minHeight: '1.25rem',
    padding: '6px 12px',

    '&:focus': {
      opacity: 1,
    },
  },
  selected: {
    pointerEvents: 'none',
  },
}))((props) => <Tab component={Link} disableRipple {...props} />);

const HeaderTabs = ({ value, search, onChange }) => (
  <StyledTabs value={value} onChange={onChange}>
    <StyledTab
      data-testid="sections-tab"
      label="Sections"
      to={`${PAGE_START}?${search}`}
    />
    <StyledTab
      data-testid="routes-tab"
      label="Routes"
      to={`${ROUTES_PAGE}?${search}`}
    />
  </StyledTabs>
);

export default memo(HeaderTabs);
